/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPFREQUENCY } from './IAPFREQUENCY';
import {
    IAPFREQUENCYFromJSON,
    IAPFREQUENCYFromJSONTyped,
    IAPFREQUENCYToJSON,
} from './IAPFREQUENCY';

/**
 * 
 * @export
 * @interface ProposalSummaryRegularWithdrawals
 */
export interface ProposalSummaryRegularWithdrawals {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRegularWithdrawals
     */
    grossAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRegularWithdrawals
     */
    netAmount?: number;
    /**
     * 
     * @type {IAPFREQUENCY}
     * @memberof ProposalSummaryRegularWithdrawals
     */
    frequency?: IAPFREQUENCY;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryRegularWithdrawals
     */
    frequencyName: string;
    /**
     * 
     * @type {Date}
     * @memberof ProposalSummaryRegularWithdrawals
     */
    paymentMonth?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRegularWithdrawals
     */
    growthRatePercentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryRegularWithdrawals interface.
 */
export function instanceOfProposalSummaryRegularWithdrawals(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "frequencyName" in value;

    return isInstance;
}

export function ProposalSummaryRegularWithdrawalsFromJSON(json: any): ProposalSummaryRegularWithdrawals {
    return ProposalSummaryRegularWithdrawalsFromJSONTyped(json, false);
}

export function ProposalSummaryRegularWithdrawalsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryRegularWithdrawals {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'grossAmount': !exists(json, 'GrossAmount') ? undefined : json['GrossAmount'],
        'netAmount': !exists(json, 'NetAmount') ? undefined : json['NetAmount'],
        'frequency': !exists(json, 'Frequency') ? undefined : IAPFREQUENCYFromJSON(json['Frequency']),
        'frequencyName': json['FrequencyName'],
        'paymentMonth': !exists(json, 'PaymentMonth') ? undefined : (new Date(json['PaymentMonth'])),
        'growthRatePercentage': !exists(json, 'GrowthRatePercentage') ? undefined : json['GrowthRatePercentage'],
    };
}

export function ProposalSummaryRegularWithdrawalsToJSON(value?: ProposalSummaryRegularWithdrawals | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'GrossAmount': value.grossAmount,
        'NetAmount': value.netAmount,
        'Frequency': IAPFREQUENCYToJSON(value.frequency),
        'FrequencyName': value.frequencyName,
        'PaymentMonth': value.paymentMonth === undefined ? undefined : (value.paymentMonth.toISOString()),
        'GrowthRatePercentage': value.growthRatePercentage,
    };
}

